import { network } from "../network/network.js";
export async function globalSearch(query) {
    return await network("/search", { query: { query } });
}
